$(function () {
    initieraToppBildSlideshow();
    animeraBlock();
    animeraBildtextVidScroll();

    function initieraToppBildSlideshow() {
        if (location.href.indexOf('episerver/cms/') < 0) {
            $('#topp-bild-slideshow').slick({
                arrows: false,
                dots: false,
                infinite: true,
                speed: 2000,
                fade: true,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: false
            });
        }
    }

    function animeraBlock() {
        if ('IntersectionObserver' in window) {
            const blocks = document.querySelectorAll('.fotogalleriblocklista .block, .text-mobil-puff');
            const blocksObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    const block = entry.target;
                    const hasAnimated = block.classList.contains('animate');
                    const img = block.querySelector('img[data-src]');

                    if (entry.isIntersecting && !hasAnimated) {
                        if (img) {
                            img.src = img.getAttribute('data-src') || '';
                        }
                        block.classList.add('animate');
                        blocksObserver.unobserve(block);
                    }
                });
            }, {
                rootMargin: '0%'
            });

            blocks.forEach(block => {
                blocksObserver.observe(block);
            });
        }
    }

    function animeraBildtextVidScroll() {
        $('#fotogalleri-slideshow').on('wheel', function (e) {
            var citat = $(this).find('.slick-current .citat-hover');
            var delta = e.originalEvent.wheelDelta;
            if (delta < 0) {
                citat.addClass('scroll');
            } else {
                citat.removeClass('scroll');
            }
        });
    }
});

$(window).on('load', function () {
    initieraBildspel();
    initieraFotoGalleriSlideshow();

    function initieraBildspel() {
        const modal = $('#fotogalleri-modal');
        const slideShow = $('#fotogalleri-slideshow');
        let items = [];

        $('.js-bildspel').each(function (index) {
            $(this).data('index', index);
        });
        $('.js-bildspel-bildurl').each(function () {
            let title = '';
            if ($(this).siblings('[data-title]').length > 0) {
                title = $(this).siblings('[data-title]')[0].innerHTML;
            }

            let item = {};
            item.src = $(this).val();
            item.title = title;
            item.w = $(this).data('width');
            item.h = $(this).data('height');
            items.push(item);
        });
        alectaBildspel(items);

        $(document).on('mouseover', '.js-bildspel', function () {
            let current = $(this).data('index');
            lazyLoadImage(current);
        });

        $(document).on('click', '.js-bildspel', function () {
            const nrOfSlides = items.length - 1;
            let current = $(this).data('index');
            let next = current + 1 > nrOfSlides ? 0 : current + 1;
            let prev = current - 1 < 0 ? nrOfSlides : current - 1;

            lazyLoadImage(current);
            lazyLoadImage(next);
            lazyLoadImage(prev);

            slideShow.slick('slickGoTo', current);
            $('.citat-hover').removeClass('show');
            modal.modal();
        });
    }

    function alectaBildspel(items) {
        const bildspel = document.getElementById('fotogalleri-slideshow');
        const divStart = '<div class="block fotogalleriblock"><div class="block-inner">';
        const fotoDivStart = '<div class="foto"><div class="slide-button-prev hidden-xs visible-lg"></div>';
        const fotoDivEnd = '<div class="slide-button-next hidden-xs visible-lg"></div></div>';
        const titleDivStart = '<div data-title class="bild-text">';
        const titleDivEnd = '</div></div>';
        const slideButtons = '<div class="slide-buttons hidden-lg"><div class="slide-button-prev"></div><div class="slide-button-next"></div></div></div>';

        items.forEach(item => {
            let foto = fotoDivStart + '<img data-src="' + item.src + '" />' + fotoDivEnd;
            let title = titleDivStart + item.title + titleDivEnd;
            let html = divStart + foto + title + slideButtons;
            bildspel.innerHTML += html;
        });
    }

    function lazyLoadImage(c) {
        let img = $('[data-slick-index="' + c + '"]').find('img[data-src]');
        if (img.prop('src').length === 0) {
            img.prop('src', img.data('src') || '');
        }
    }

    function initieraFotoGalleriSlideshow() {
        $('#fotogalleri-slideshow').on('beforeChange', function (event, slick, previousSlide, currentSlide) {
            let lastSlide = slick.slideCount - 1;
            let nextSlide = previousSlide < currentSlide ? currentSlide + 1 : currentSlide - 1;
            if (nextSlide > lastSlide) {
                nextSlide = 0;
            } else if (nextSlide < 0) {
                nextSlide = lastSlide;
            }
            if (previousSlide === lastSlide && currentSlide === 0) {
                nextSlide = currentSlide + 1;
            } else if (previousSlide === 0 && currentSlide === lastSlide) {
                nextSlide = currentSlide - 1;
            }
            document.getElementById('fotogalleri-modal').scrollTo({top: 0, behavior: 'smooth'});
            lazyLoadImage(nextSlide);
        });

        $('#fotogalleri-slideshow').slick({
            arrows: true,
            dots: false,
            infinite: true,
            speed: 800,
            fade: true,
            prevArrow: '.slide-button-prev',
            nextArrow: '.slide-button-next',
            autoplay: false,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            mobileFirst: true,
            swipe: true
        });

        $('#fotogalleri-modal').on('shown.bs.modal', function () {
            $('#fotogalleri-slideshow').slick('setPosition');
        });
    }
});
